
export default function Loading()
{

    return(
        <div className="darkness-loading">
            <img src='/images/icons/loading_200_black.gif' alt='loading'/>
        </div>
    )
}